<div mat-dialog-title>Hitta dokument</div>
<div class="content">
  <mat-form-field>
    <input (keydown.enter)="findPackage()"
           [formControl]="sub"
           matInput placeholder="Sök personnummer"
           spbPersonnummerValidator>
  </mat-form-field>
</div>

<mat-dialog-actions>
  <button matDialogClose="cancel" matButton="outlined">Stäng</button>
  <button (click)="findPackage()" [disabled]="sub.invalid"
          matButton="filled">Sök
  </button>
</mat-dialog-actions>